import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Styled from 'styled-components'
import { SET_ROUTE } from 'estimate_list/reducers/initial'
import Select from '../layout/select'

const SIZE = ['30', '60', '90']

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
const FilterArea = () => {
    const { domain, route } = useSelector((state) => state.initial)

    const dispatch = useDispatch()

    const onClickSort = (sort) => () => {
        dispatch({
            type: SET_ROUTE,
            data: { sort },
        })
    }

    const onClickSize = (size) => {
        dispatch({
            type: SET_ROUTE,
            data: { size: String(size) },
        })
    }

    /**
     * 보기 방식을 리스트와 썸네일(그리드) 형태로 전환한다.
     * @param types
     * @returns {(function(): void)|*}
     */

    const onClickTypes = (types) => () => {
        dispatch({
            type: SET_ROUTE,
            data: { types },
        })
        // setCookie('viewType', types, 9 * 24 * 60 * 60)
    }

    // 2022-08-02 현금가(전체 최저가), 카드가(카드 최저가) 노출되게 수정
    const onClickType = (type) => () => {
        dispatch({
            type: SET_ROUTE,
            data: { type },
        })
    }

    return (
        <FilterAreaStyle domain={domain}>
            <div className="sort_area">
                <div className="sort_box">
                    <button
                        type="button"
                        onClick={onClickSort('rank')}
                        className={`sort ${route.sort === 'rank' ? 'active' : ''}`}
                    >
                        인기상품순
                    </button>
                    <button
                        type="button"
                        onClick={onClickSort('date')}
                        className={`sort ${route.sort === 'date' ? 'active' : ''}`}
                    >
                        신상품순
                    </button>
                    <button
                        type="button"
                        onClick={onClickSort('price_desc')}
                        className={`sort ${route.sort === 'price_desc' ? 'active' : ''}`}
                    >
                        높은 가격순
                    </button>
                    <button
                        type="button"
                        onClick={onClickSort('price_asc')}
                        className={`sort ${route.sort === 'price_asc' ? 'active' : ''}`}
                    >
                        낮은 가격순
                    </button>
                    <button
                        type="button"
                        onClick={onClickSort('abc')}
                        className={`sort ${route.sort === 'abc' ? 'active' : ''}`}
                    >
                        가나다순
                    </button>
                    <button
                        type="button"
                        onClick={onClickSort('mall')}
                        className={`sort ${route.sort === 'mall' ? 'active' : ''}`}
                    >
                        판매점순
                    </button>
                    <button
                        type="button"
                        onClick={onClickSort('review')}
                        className={`sort ${route.sort === 'review' ? 'active' : ''}`}
                    >
                        상품평순
                    </button>
                    <button
                        type="button"
                        id={`devBtnTypeCash`}
                        style={{ display: 'none' }}
                        onClick={onClickType('cash')}
                        className={`sort`}
                    >
                        현금
                    </button>
                    <button
                        type="button"
                        id={`devBtnTypeCard`}
                        style={{ display: 'none' }}
                        onClick={onClickType('card')}
                        className={`sort`}
                    >
                        카드
                    </button>
                </div>
                <div className="sort_choice">
                    <Select
                        activeSelect={SIZE.indexOf(route.size) > -1 ? route.size / 30 - 1 : 0}
                        option={[
                            { value: 30, text: '30개씩 보기' },
                            { value: 60, text: '60개씩 보기' },
                            { value: 90, text: '90개씩 보기' },
                        ]}
                        optionClick={onClickSize}
                    />
                    {domain === 'shopping' && (
                        <div className="type_choice">
                            <button
                                type="button"
                                className={`btn_list ${route.types === 'list' ? 'active' : ''}`}
                                onClick={onClickTypes('list')}
                            />
                            <button
                                type="button"
                                className={`btn_thumb ${route.types === 'thumb' ? 'active' : ''}`}
                                onClick={onClickTypes('thumb')}
                            />
                        </div>
                    )}
                </div>
            </div>
        </FilterAreaStyle>
    )
}

const FilterAreaStyle = Styled.div`
    border-bottom: 1px solid #999;

    .sort_area {
        position: relative;
        border-top: ${(props) => (props.domain === 'minishop' ? '2px solid #418ded' : '')};
    }
    .sort_box {
        padding: 7px 0;

        button {
            position: relative;
            color: #666;
            margin: 0 10px;
            height: 28px;
            line-height: 28px;

            &:not(:first-child):after {
                content: '';
                width: 1px;
                height: 8px;
                position: absolute;
                top: 11px;
                left: -10px;
                background: #999
            }

            &.active {
                color: #418ded;
                margin-left: 5px;

                &:before {
                    content: '\\e9ea';
                    margin: 0 2px 0 0;
                    font-family: 'ppingkr_v4';
                    font-size: 10px;
                    transform: scale(0.7);
                    display: inline-block;
                }
            }
        }
    }
    .sort_choice {
        position: absolute;
        top: 7px;
        right: 0;
    }
    .type_choice {
        display: inline-block;
        margin-left: 8px;

        .btn_list,
        .btn_thumb {
            position: relative;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #999;
            overflow: hidden;
            color: transparent;
            width: 28px;
            height: 28px;
            background: transparent;
            vertical-align: top;

            &.active {
                border: 1px solid #418ded;
                z-index: 1;

                &:before {
                    color: #418ded
                }
            }
            &:before {
                font-family: 'ppingkr_v4';
                color: #999;
                font-size: 12px;
            }
        }
        .btn_list {
            &:before {
                content: '\\e98e';
                font-size: 20px;
                transform: scaleX(1.2);
                display: inline-block;
            }
        }
        .btn_thumb {
            margin-left: -1px;

            &:before {
                content: '\\e976';
            }
        }
    }
`

export default FilterArea



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/list_filter_area.js